import { render, staticRenderFns } from "./newPoster.vue?vue&type=template&id=281fb5b0&scoped=true&"
import script from "./newPoster.vue?vue&type=script&lang=js&"
export * from "./newPoster.vue?vue&type=script&lang=js&"
import style0 from "./newPoster.vue?vue&type=style&index=0&id=281fb5b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281fb5b0",
  null
  
)

export default component.exports